/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function getSeparatorIndexes(children) {
  return children.reduce(function (acc, child, index) {
    if (child === '-' || child.props && child.props.isSeparator) {
      acc.push(index);
    }
    return acc;
  }, []);
}
var _default = getSeparatorIndexes;
exports.default = _default;